/**
 *
 * @param {string} name
 * @param subqueries
 */
export function createWidgetQuery(name, subqueries) {
	const query = JSON.parse(name);

	// Append a custom column corresponding to the result of the subquery element count
	for (const item of subqueries) {
		query.select.push({
			type: 'query',
			kid: item.kid,
			op: 'count',
			node: 'KID',
			kdata: {
				label: item.name,
			},
			path: [],
			width: 120,
		});
	}

	return query;
}
